// extracted by mini-css-extract-plugin
export default {"accountFio":"fioAccount_accountFio__qlRTq"};